export enum Alerts {
  GET_USER_ALERTS_REQUEST = '@alerts/GET_USER_ALERTS_REQUEST',
  GET_USER_ALERTS_SUCCESS = '@alerts/GET_USER_ALERTS_SUCCESS',
  GET_USER_ALERTS_FAIL = '@alerts/GET_USER_ALERTS_FAIL',
}
